import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  apply(event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return

    const item = event.target.closest("[data-direction]")
    if (!item || !this.element.contains(item)) return

    const form = this.element.closest("form")
    const column = form?.querySelector("#content-patient-library-column")
    const direction = form?.querySelector("#content-patient-library-direction")
    if (!column || !direction) return

    event.preventDefault()
    column.value = item.dataset.value || ""
    direction.value = item.dataset.direction
    form.requestSubmit()
  }
}
